var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6179_3338",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6179_3338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.962 20C9.93133 20 8.16117 19.3368 6.6515 18.0105C5.14183 16.6843 4.26842 15.0142 4.03125 13H5.04275C5.31458 14.7205 6.09825 16.1507 7.39375 17.2905C8.68925 18.4302 10.212 19 11.962 19C13.912 19 15.5662 18.3208 16.9245 16.9625C18.2828 15.6042 18.962 13.95 18.962 12C18.962 10.05 18.2828 8.39583 16.9245 7.0375C15.5662 5.67917 13.912 5 11.962 5C10.9273 5 9.95492 5.21858 9.04475 5.65575C8.13442 6.09292 7.33117 6.69483 6.635 7.4615H9.116V8.4615H4.962V4.30775H5.962V6.69625C6.73517 5.84742 7.64125 5.18583 8.68025 4.7115C9.71942 4.23717 10.8133 4 11.962 4C13.071 4 14.1104 4.20867 15.0803 4.626C16.0501 5.04333 16.8975 5.6145 17.6225 6.3395C18.3475 7.0645 18.9187 7.91192 19.336 8.88175C19.7533 9.85158 19.962 10.891 19.962 12C19.962 13.109 19.7533 14.1484 19.336 15.1183C18.9187 16.0881 18.3475 16.9355 17.6225 17.6605C16.8975 18.3855 16.0501 18.9567 15.0803 19.374C14.1104 19.7913 13.071 20 11.962 20ZM15.166 15.8538L11.5197 12.2078V7H12.5197V11.7923L15.8735 15.1463L15.166 15.8538Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.d7110345d2cb3d28d31a5030ca9dd89c.svg";
export { ForwardRef as ReactComponent };